import React, { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabase';
import { useAuth } from '../../contexts/AuthContext';
import { Link } from 'react-router-dom';

const Brands: React.FC = () => {
  const { user } = useAuth();
  const [brands, setBrands] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return; // Guard clause: don't run if user is null
    const fetchBrands = async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from('brands')
        .select('*')
        .eq('user_id', user.id);
      if (!error) setBrands(data || []);
      setLoading(false);
    };
    fetchBrands();
  }, [user]);

  return (
    <>
      <div className="flex items-center justify-between mb-8">
        <h1 className="text-2xl font-bold text-gray-900">Brands</h1>
        <Link
          to="/dashboard/brands/create"
          className="flex items-center px-4 py-2 bg-primary text-white rounded-lg shadow hover:bg-primary/90 transition"
        >
          <span className="material-icons mr-2 text-lg">add</span>
          Create Brand
        </Link>
      </div>
      <h2 className="text-lg font-semibold text-gray-700 mb-6">Select a Brand</h2>
      {loading ? (
        <div>Loading...</div>
      ) : brands.length === 0 ? (
        <div className="text-gray-500">No brands found.</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {brands.map((brand) => (
            <div
              key={brand.id}
              className="flex items-center bg-white rounded-xl shadow border p-6 hover:shadow-lg transition cursor-pointer"
            >
              <div className={`flex items-center justify-center w-14 h-14 rounded-full font-bold text-lg mr-6 bg-blue-100 text-blue-600`}>
                {brand.name?.slice(0, 2).toUpperCase()}
              </div>
              <div className="flex-1">
                <div className="font-semibold text-base text-gray-900">{brand.name}</div>
                <div className="text-gray-500 text-sm">{brand.description}</div>
                <div className="flex items-center mt-2 text-xs text-gray-400">
                  <span className="material-icons text-base mr-1">groups</span>
                  {brand.team}
                </div>
              </div>
              <span className="material-icons text-gray-300 ml-4">chevron_right</span>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default Brands; 